import styled from "styled-components";

type RnsIconSizeCustomType = {
  size: number;
};

/**
 * @description `@fluentui/react-northstar` 에서 제공하는 Icon의 경우 제공하는 Size이외 원하는 값으로 크기 조정이 안됩니다. 이를 변경하기 위한 스타일 입니다.
 */
export const RnsIconSizeCustom = styled.div<RnsIconSizeCustomType>`
  & > span:nth-child(1) {
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    & > svg {
      width: initial;
      height: initial;
    }
  }
`;
